import {useRef, useState, useEffect} from 'react';
import {pool} from 'workerpool';
import {handleError, useNamedSelector} from 'helpers';

const worker = pool('/static/worker.js');

export function useSelectorInBackground(path: string, ...options: any[]) {
  const data = useNamedSelector(path, ...options);
  const ref = useRef<HTMLElement>(null);
  const [inViewport, setInViewport] = useState(false);
  const [result, setResult] = useState();

  useEffect(() => {
    if (inViewport) {
      const task = worker.exec(path, [data]);
      task.then(setResult).catch(onFail);
      return () => {
        task.cancel();
      };
    }
  }, [data, inViewport]);

  useEffect(() => {
    if (ref.current) {
      const observer = new IntersectionObserver(([{isIntersecting}]) => {
        if (isIntersecting) {
          setInViewport(true);
          observer.disconnect();
        }
      });
      observer.observe(ref.current);
      return () => observer.disconnect();
    }
  }, []);

  return [ref, result, result === undefined];
}

function onFail(error: Error) {
  if (error.message !== 'promise cancelled') {
    handleError(error);
  }
}
